/**
 * ダイアログ表示中でもピンチ（拡大縮小）を効かせるためのフック。
 *
 * Headless UI の Dialog は iOS で背景スクロールを止めるために、
 * document の touchmove を非パッシブに拾って preventDefault する
 * （@headlessui/react の handle-ios-locking）。
 * WebKit では touchmove の preventDefault がピンチもキャンセルしてしまうため、
 * 画面を拡大した状態でダイアログを開くと縮小できなくなり、
 * 画面外に出たボタンに届かなくなる（LINE アプリ内ブラウザで発生）。
 *
 * document のキャプチャ段階で「指が2本以上のときだけ」伝播を止めると、
 * Headless UI のロックにも自前のハンドラーにも届かなくなり、
 * ブラウザ本来のピンチ操作がそのまま働く。
 * 指1本のときは何もしないので、背景スクロールのロックは今まで通り効く。
 *
 * stopPropagation は既定動作を止めないので、ピンチ自体は通常どおり行われる。
 */
import { useEffect } from 'react';

export function useAllowPinchZoom(
  active: boolean,
  /** ピンチが始まったときに、進行中の1本指ジェスチャーを取り消すための後始末 */
  onPinch?: () => void,
) {
  useEffect(() => {
    if (!active) return;
    const handler = (e: TouchEvent) => {
      if (e.touches.length <= 1) return;
      onPinch?.();
      e.stopPropagation();
    };
    document.addEventListener('touchmove', handler, { capture: true });
    return () => document.removeEventListener('touchmove', handler, { capture: true });
  }, [active, onPinch]);
}
